export enum OrderStatus {
  Pending = 0,
  Unknown = 1,
  Error = 2,
  Failed = 3,
  Succeeded = 4,
}
